import { render } from "./HomePage.vue?vue&type=template&id=27b858d8&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=27b858d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27b858d8"

export default script